import styled from 'styled-components';
import device from '../../../components/mediaQueries';

const BrowseTileImageContainer = styled.div`
  position: relative;
  text-align: center;
  background-repeat: no-repeat;
  ${device.mobile`
    width: 180px;
    height: 165px;
    background: url('${({ image }) => `${image}_mobile.jpg`}');
  `}
  ${device.desktop`
    width: 480px;
    height: 200px;
    background: url('${({ image }) => `${image}_desktop.jpg`}');
  `}
`;

export default BrowseTileImageContainer;
